import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import ListPagesService from '../../Services/Queries/ListPages'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { widthPercentageToDP } from '../../Utils/ResponsiveScreen'

class ListPages extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  constructor(props) {
    super(props)

    this.state = {
      limit: 25,
      nextToken: null,
      headings: [
        'Num',
        'Page Value',
        'Page Type',
        'Image',
        'Page Title',
        'Page Description',
        'Subscription Status',
      ],
      pageList: [],
      showOnlyImages: false,
    }

    this.loadMore = this.loadMore.bind(this)
  }
  loadMore = async () => {
    await this.getNextPagesLists()
  }
  getPagesLists = async () => {
    const input = {
      limit: this.state.limit,
    }
    console.log(input, 'inputttt')
    const data = await ListPagesService(input)
    console.log(data, 'dataaaaa')
    this.setState({
      pageList: data.items,
      nextToken: data.nextToken,
    })
  }
  getNextPagesLists = async () => {
    const input = {
      limit: this.state.limit,
      nextToken: this.state.nextToken,
    }
    const data = await ListPagesService(input)
    this.setState({
      pageList: [...this.state.pageList, ...data.items],
      nextToken: data.nextToken,
    })
  }

  async componentDidMount() {
    this.getPagesLists()
  }

  renderTable = (heading, contentList) => {
    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            {heading.map((head) => (
              <th>{head}</th>
            ))}
          </tr>
        </thead>
        <tbody>{contentList.map((row, index) => this.renderTableRow(row, index))}</tbody>
      </Table>
    )
  }

  renderTableRow = (item, index) => {
    const pageValue = item.pageValue
    const PK = pageValue.replace('page#', '')
    return (
      <tr>
        <td>{index + 1}</td>
        <td>{item.pageValue}</td>
        <td>{item.pageTemplate}</td>
        <td>
          <img style={{ maxWidth: '50%', height: 50 }} src={item.pageThumbnail} />
        </td>
        <td>{item.pageTitle}</td>
        <td>{item.pageDescription}</td>
        <td>{item.pageSubscriptionStatus}</td>
      </tr>
    )
  }

  renderBigImages = (pageList) => {
    return (
      <div
        style={{
          width: window.width - 50,
          height: window.height - 50,
          flexDirection: 'row',
        }}
      >
        {pageList?.map(({ pageThumbnail }, index) => {
          return (
            <span>
              <span
                style={{
                  width: 150,
                  height: 150,
                }}
              >
                <text>{`${index + 1}>`}</text>
                <img style={{ width: 150, height: 150, margin: 10 }} src={pageThumbnail} />
              </span>
            </span>
          )
        })}
      </div>
    )
  }

  render() {
    const { pageList, headings } = this.state
    return (
      <section className='feed'>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <input
          type='checkbox'
          checked={this.state.showOnlyImages}
          onClick={() => {
            this.setState({ showOnlyImages: !this.state.showOnlyImages })
          }}
        />
        <text>Show only Images</text>
        {!this.state.showOnlyImages ? (
          <div style={{ marginTop: 10 }}>{this.renderTable(headings, pageList)}</div>
        ) : (
          <div style={{ marginTop: 10 }}>{this.renderBigImages(pageList)}</div>
        )}

        {this.state.nextToken != null && (
          <button onClick={this.loadMore} type='button' className='load-more'>
            Load more
          </button>
        )}
      </section>
    )
  }
}

export default ListPages
